import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Typography, Grid } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
	},
	inner: {
		padding: theme.spacing(6, 3),
		width: theme.breakpoints.values.lg,
		maxWidth: '100%',
		margin: '0 auto',
	},
	media: {
		'& img': {
			width: '100%',
			height: 'auto',
		},
	},
}));

const UserFlows = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<div className={classes.inner}>
				<Grid alignItems="center" container justifyContent="space-between">
					<Grid item lg={3} md={6} xs={12}>
						<Typography gutterBottom variant="h3">
							Complete User Flows
						</Typography>
						<Typography variant="subtitle2">
							Not just a set of tools, the package includes the
							most common use cases of user flows like User
							Management, Second Level Layout, and many more.
						</Typography>
					</Grid>
					<Grid className={classes.media} item lg={4} md={6} xs={12}>
						<img
							alt="User flows"
							src="./images/presentation/user_flows.png"
						/>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

UserFlows.propTypes = {
	className: PropTypes.string,
};

export default UserFlows;
